import { put, select } from "redux-saga/effects";
import UserActions from "../reducers/UserReducer";
import OrganizationActions from "../reducers/OrganizationReducer";
import SettingAction from "../reducers/SettingReducer";
import Token from "../util/token";
import { history } from "../reducers/configureStore";

import ROUTE from "../constants/route";

const startup = function* (action) {
	const token = yield select(state => state.authen.token);
	const user = yield select(state => state.user.user);
	yield put(SettingAction.clearTemporary());
	if (token && Token.validateToken(token)) {
		yield put(UserActions.getUserRequest());
		if (user.roles.indexOf("superadmin") !== -1) {
			const orgID = yield select(state => state.organization.orgID);
			orgID ? yield put(OrganizationActions.getOrganizationRequest()):
			 history.push(`/${ROUTE.CORPORATE_LIST}`);
		} else
			yield put(OrganizationActions.getOrganizationRequest());
	}
};
export { startup };



// WEBPACK FOOTER //
// ./src/sagas/StartupSaga.js